import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/auth/LoginPage';
import RegisterPage from './pages/auth/RegisterPage';
import ForgotPasswordPage from './pages/auth/ForgotPasswordPage';
import HomeLayout from './pages/HomeLayout';
import ExamRunnerPage from './pages/exam/ExamRunnerPage';
import ReportPage from './pages/exam/ReportPage';
import { useAuthStore } from './stores/authStore';

/** 受保护的路由 */
const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { accessToken } = useAuthStore();
  if (!accessToken) return <Navigate to="/login" replace />;
  return <>{children}</>;
};

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/exam/:id" element={<ProtectedRoute><ExamRunnerPage /></ProtectedRoute>} />
        <Route path="/report/:attemptId" element={<ProtectedRoute><ReportPage /></ProtectedRoute>} />
        <Route path="/" element={<ProtectedRoute><HomeLayout /></ProtectedRoute>} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
